import { BadgeCheck } from "lucide-react";
import { Badge } from "./badge";
import { useTranslation } from "react-i18next";
import Top3 from '../../assets/icons/top-3.png'
import Top5 from '../../assets/icons/top-5.png'

interface AllCorrectBadgeProps {
  ThreePlayerProno?: boolean
}

export default function AllCorrectBadge({ThreePlayerProno = true}: AllCorrectBadgeProps){
  const { t } = useTranslation()
  return (  
      <div className="flex flex-wrap gap-2">
        <Badge variant="outline" className="rounded-full text-white">
          <img src={ThreePlayerProno ? Top3 : Top5} className="w-5 h-5"/>
            {t("all-correct-badge.all-correct")}
        </Badge>
      </div>
    )
}